var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13.0002C4 11.1146 4 10.1718 4.58579 9.58598C5.17157 9.0002 6.11438 9.0002 8 9.0002H16C17.8856 9.0002 18.8284 9.0002 19.4142 9.58598C20 10.1718 20 11.1146 20 13.0002V15.0002C20 17.8286 20 19.2428 19.1213 20.1215C18.2426 21.0002 16.8284 21.0002 14 21.0002H10C7.17157 21.0002 5.75736 21.0002 4.87868 20.1215C4 19.2428 4 17.8286 4 15.0002V13.0002Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.00001L16.5776 8.37942C16.8365 6.30783 15.9043 4.26745 14.1688 3.10704V3.10704C12.1024 1.72538 9.36732 1.89568 7.48825 3.523L6.66992 4.23169",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.d7539894102f1041a0e696dbc5ae2bf1.svg";
export { ForwardRef as ReactComponent };